import { InfoContainer, InfoText, RootContainer } from './StepperStyle';
import { RoundStep, RoundStepButton, RoundStepperRoot } from './RoundStepperStyle';
import { Step, StepperVariant } from '../../types/stepper';
import {
  BarStep,
  BarStepButton,
  BarStepButtonIcon,
  BarStepButtonIconE,
  BarStepperRoot,
} from './BarStepperStyle';

export interface StepperProps {
  variant?: StepperVariant;
  steps: Step[];
  activeStep: number;
  isClickable?: boolean;
  nonLinear?: boolean;
  onChange?: (id: number) => void;
  transformBarStepLabel?: (label: string) => string;
}

export default function Stepper({
  variant = StepperVariant.DEFAULT,
  steps,
  activeStep = 0,
  isClickable = false,
  nonLinear = true,
  onChange = () => {},
  transformBarStepLabel,
  ...rest
}: StepperProps) {
  const StepperRoot = variant === StepperVariant.DEFAULT ? RoundStepperRoot : BarStepperRoot;
  const Step = variant === StepperVariant.DEFAULT ? RoundStep : BarStep;
  const StepButton = variant === StepperVariant.DEFAULT ? RoundStepButton : BarStepButton;

  return (
    <RootContainer stepperType={variant} {...rest}>
      {variant === StepperVariant.BAR && (
        <InfoContainer>
          <InfoText>
            {transformBarStepLabel
              ? transformBarStepLabel(steps[activeStep]?.name)
              : steps[activeStep]?.name}
          </InfoText>
          <InfoText>
            {activeStep + 1}/{steps.length}
          </InfoText>
        </InfoContainer>
      )}
      <StepperRoot nonLinear={nonLinear} activeStep={activeStep}>
        {steps.map((step, index) => (
          <Step key={step.name} completed={step.isComplete}>
            <StepButton
              icon={
                variant === StepperVariant.BAR ? (
                  <BarStepButtonIcon className='icon-e'>
                    {index <= activeStep && (
                      <BarStepButtonIconE fullWidth={step.isComplete}></BarStepButtonIconE>
                    )}
                  </BarStepButtonIcon>
                ) : undefined
              }
              color='inherit'
              onClick={() => onChange(index)}
              disabled={!isClickable}
            >
              {step.name}
            </StepButton>
          </Step>
        ))}
      </StepperRoot>
    </RootContainer>
  );
}
